import React, { useState } from "react";
import { Header, PlanContainer, Body, Footer, DurationBox } from "./style";
import { Confirm } from "../../../../components/confirm";
import { withRouter } from "react-router-dom";
import { PHONE_LINK } from "../../../../constants/contactUs";
import { Spinner } from "../../../../components/loading";
import { detectPhoneNumber } from "../../../../lib/detectPhoneNumber";
import { WARNING_SINGLE_BUTTON_TEXT } from "../../../../constants/otherTexts";
import { convertRialToToman } from "../../../../lib/convertRialToToman";

const Index = props => {
  const {
    data: {
      id,
      color,
      title,
      sub_title,
      features,
      durations,
      buy_text,
      is_special,
      is_free,
      buy_flag,
      last_plan_text
    },
    trial_flag,
    calculatePrice,
    buyGift,
    loading,
    setClickedPlan,
    clickedPlan,
    selectedDuration,
    setSelectedDuration
  } = props;
  const [showConfirm, setShowConfirm] = useState(false);

  const onButtonHandleClick = giftDurationId => {
    setClickedPlan(id);
    if (is_special) {
      //call to buy
      window.open(PHONE_LINK);
    } else {
      if (!buy_flag) {
        //confirm buy_text
        setShowConfirm(true);
      } else {
        if (giftDurationId) {
          buyGift({ plan_id: id, duration_id: giftDurationId });
        } else {
          calculatePrice({ plan_id: id, duration_id: selectedDuration });
        }
      }
    }
  };
  const closeConfirm = () => {
    setShowConfirm(false);
    // history.goBack();
  };
  const selectedPrice = () => {
    if (durations && selectedDuration) {
      const selectedDurations = durations.filter(
        dur => dur.id === selectedDuration
      );
      if (selectedDurations.length > 0) {
        return selectedDurations[0].price;
      }
    }
    return 0;
  };
  const renderLastPlanText = () => {
    return detectPhoneNumber(last_plan_text);
  };
  const renderGiftPlan = () => {
    const giftPlanArr = durations.filter(dur => dur.is_gift);
    if (giftPlanArr.length > 0) {
      return (
        <div
          className="gift-text"
          onClick={() => onButtonHandleClick(giftPlanArr[0].id)}
        >
          {giftPlanArr[0].description}
        </div>
      );
    }
  };
  return (
    <React.Fragment>
      <Confirm
        show={showConfirm}
        rejectHandler={() => closeConfirm()}
        close={() => closeConfirm()}
        content={{
          type: "warning",
          title: "توجه!",
          message: buy_text,
          rejectButtonText: WARNING_SINGLE_BUTTON_TEXT,
          icon: "icon mapsa-notification"
        }}
      />
      <PlanContainer
        id={id}
        disabled={loading && id !== clickedPlan}
        className="plan"
      >
        <Header color={color}>
          {title}
          {sub_title && <div className="notice">{sub_title}</div>}
        </Header>
        <Body showTraial={trial_flag}>
          {features.map((text, i) => {
            const isBoldText = i === 0;
            if (text) {
              return (
                <li
                  className={`feature-item${isBoldText ? " first-item" : ""}`}
                  key={i}
                >
                  {text}
                </li>
              );
            }
          })}
          {last_plan_text && (
            <div
              className="extra-info"
              dangerouslySetInnerHTML={{ __html: renderLastPlanText() }}
            />
          )}
        </Body>
        <Footer
          defaultFooterTextColor={is_special}
          showTraial={trial_flag}
          verticallyCenter={is_free}
        >
          {!is_free && durations.length > 0 && (
            <div className="durations">
              {durations
                .filter(dur => !dur.is_gift)
                .map((duration, i) => {
                  const selected = selectedDuration === duration.id;
                  const isDiscounted = duration.real_price !== duration.price;
                  const discount =
                    duration.real_price > 0 &&
                    Math.ceil(
                      100 *
                        ((duration.real_price - duration.price) /
                          duration.real_price)
                    );
                  return (
                    <DurationBox
                      selected={selected}
                      key={i}
                      onClick={() => setSelectedDuration(duration.id)}
                    >
                      <div className="text">{duration.title}</div>
                      <div className="text">
                        {convertRialToToman(duration.price)}
                        <span className="unit"> تومان</span>
                      </div>
                      {isDiscounted && (
                        <div className="colored-text">
                          {convertRialToToman(duration.real_price)}
                          <span className="unit"> تومان</span>
                        </div>
                      )}
                      {isDiscounted && (
                        <span className="discount">{discount}%</span>
                      )}
                    </DurationBox>
                  );
                })}
            </div>
          )}
          {(is_free || is_special) && (
            <div className="footer-text">{buy_text}</div>
          )}
          {!is_free && (
            <div
              className="purchase-button"
              onClick={() => onButtonHandleClick()}
            >
              {loading && id === clickedPlan ? (
                <Spinner />
              ) : (
                <React.Fragment>
                  {!is_special
                    ? `خرید (${convertRialToToman(selectedPrice())} تومان)`
                    : "تماس بگیرید"}
                </React.Fragment>
              )}
            </div>
          )}
          {!is_free && renderGiftPlan()}
        </Footer>
      </PlanContainer>
    </React.Fragment>
  );
};

export default withRouter(Index);
